import { ReactNode } from 'react';
import { StyledMessage, StyledTitle, StyledWrapper } from './ResultStyles';

interface IResult {
  children: ReactNode;
  image?: ReactNode;
  message?: string;
  title: string;
}

const Result = ({ image, title, message, children }: IResult) => {
  return (
    <StyledWrapper>
      {image}
      {!!title && <StyledTitle>{title}</StyledTitle>}
      <StyledMessage>{message}</StyledMessage>
      {children}
    </StyledWrapper>
  );
};

export default Result;
